import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    categories: [],
    entries: [],
    page: 1,
    page_size: 10,
    order_column: '',
    order_type: 'desc',
    dialogCategory: false,
    dialogEntry: false,
    category: {
      id: null,
      name: null,
      position: null
    },
    entry: {
      id: null,
      title: null,
      text: null,
      position: 0,
      category_id: null
    }
  },

  mutations: {
    setCategories(state, payload) {
      state.categories = payload
    },
    setEntries(state, payload) {
      state.entries = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedCategory(state, payload) {
      state.category = payload
    },
    setSelectedEntry(state, payload) {
      state.entry = payload
    },
    setDialogCategory(state, payload) {
      state.dialogCategory = payload
    },
    setDialogEntry(state, payload) {
      state.dialogEntry = payload
    }
  },

  actions: {
    readCategory({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/category', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setCategories', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readEntry({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/entry', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setEntries', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    deleteCategory({ dispatch }, id) {
      axios.admin.put('cms/category/delete/' + id).then(() => {
        dispatch('readCategory')
      })
    },
    deleteEntry({ dispatch }, id) {
      axios.admin.put('cms/entry/delete/' + id).then(() => {
        dispatch('readEntry')
      })
    },
    insertCategory({ commit, dispatch, state }) {
      axios.admin
        .post('cms/category', {
          name: state.category.name,
          position: state.category.position
        })
        .then(() => {
          commit('setDialogCategory', false)
          commit('setSelectedCategory', {})
          dispatch('readCategory')
        })
    },
    updateCategory({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/category/' + id, {
          name: state.category.name,
          position: state.category.position
        })
        .then(() => {
          commit('setDialogCategory', false)
          commit('setSelectedCategory', {})
          dispatch('readCategory')
        })
    },
    insertEntry({ commit, dispatch, state }) {
      axios.admin
        .post('cms/entry', {
          title: state.entry.title,
          text: state.entry.text,
          category_id: state.entry.category_id,
          position: state.entry.position
        })
        .then(() => {
          commit('setDialogEntry', false)
          commit('setSelectedEntry', {})
          dispatch('readEntry')
        })
    },
    updateEntry({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/entry/' + id, {
          title: state.entry.title,
          text: state.entry.text,
          category_id: state.entry.category_id,
          position: state.entry.position
        })
        .then(() => {
          commit('setDialogEntry', false)
          commit('setSelectedEntry', {})
          dispatch('readEntry')
        })
    }
  },

  getters: {}
}
